import { useState } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'

import { FF2, IconName, Info, TextInput } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { useConfirmation } from 'ui/hooks'
import { Col, FormRow } from 'ui/themes/globalStyles'
import { SarEdit } from '~bank-bsa-reporting/types'

type AlternateNameProps = {
  index: number
}

export const AlternateName = ({ index }: AlternateNameProps) => {
  const { control } = useFormContext<SarEdit>()
  const [itemToRemove, setItemToRemove] = useState<number | null>(null)

  const { fields, append, remove } = useFieldArray({
    control,
    name: `subjectsInfo.${index as 0}.alternateNames`
  })

  const { open: startDeleting, Confirmation } = useConfirmation({
    message: `Are you sure you want to remove this item?`,
    onConfirm: () => itemToRemove !== null && remove(itemToRemove),
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  return (
    <Info label="9. Alternate name (s)">
      {fields.map((field, index2) => (
        <Controller
          key={field.id}
          name={`subjectsInfo.${index as 0}.alternateNames.${index2 as 0}.value`}
          control={control}
          render={({ field }) => (
            <FormRow>
              <Col>
                <FF2 field={field} input={(props) => <TextInput {...props} />} />
              </Col>
              {fields.length > 1 && (
                <IconButton
                  face="negative"
                  icon={IconName.DELETE}
                  onClick={() => {
                    setItemToRemove(index2)
                    startDeleting()
                  }}
                />
              )}
            </FormRow>
          )}
        />
      ))}
      <Confirmation />
      <IconButton icon={IconName.ADD_GREEN} onClick={() => append({ value: '' })} />
    </Info>
  )
}
